import { ACT_PLC_CHANGE } from "./ActionTypes";
import PlaceService from "../provider/place/PlaceService"; // TODO
import {loading} from "./AppActions"

/*** ACTIONS PlaceS ******/
export function actionGetPlaces(succesCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      PlaceService.getPlaces(getStore().app.app).then((response) => {
        // console.log("PLACES RESPONSE", response)
        dispatch({
            type: ACT_PLC_CHANGE,
            props: {placeList:response}
        })
        succesCallback&&succesCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionSavePlace(place, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      PlaceService.savePlace(getStore().app.app, place).then((response) => {
        successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionDeletePlace(place, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      PlaceService.deletePlace(getStore().app.app, place.id).then((response) => {
        successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

/****** FIN ACTION PlaceS +**********/


// WEBPACK FOOTER //
// ./src/actions/PlaceActions.js